module.exports = __webpack_public_path__ + "static/media/president.f678f400.jpg";